export default "__VITE_ASSET__C61jrArs__"